import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { concatWithDot } from 'helpers/string';

import { prefix, QUALITY_NAMES } from './utils/form';

export const QualityControl: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.BUSINESS_OPERATIONS,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_BUSINESS_OPERATIONS.WORKING_RESOURCES,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('businessOperations.title')}
          badgeText={t('businessOperations.quality.title')}
          section={FOR_BANK_SECTIONS.BUSINESS_OPERATIONS}
        />
      </FormSectionCard>
      {/* 6.8.1 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('businessOperations.quality.factors')}
        aiFieldName={concatWithDot(prefix, QUALITY_NAMES.FACTORS)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, QUALITY_NAMES.FACTORS)}
          name={concatWithDot(prefix, QUALITY_NAMES.FACTORS)}
          minRows={4}
          disabled={!canAccess}
        />
      </FormSectionCard>
      {/* 6.8.2 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('businessOperations.quality.methods')}
        aiFieldName={concatWithDot(prefix, QUALITY_NAMES.METHODS)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, QUALITY_NAMES.METHODS)}
          name={concatWithDot(prefix, QUALITY_NAMES.METHODS)}
          minRows={4}
          disabled={!canAccess}
        />
      </FormSectionCard>
    </>
  );
};
